export default __webpack_public_path__ + "static/media/future2.7b841845.png";